import { render, staticRenderFns } from "./realResults.vue?vue&type=template&id=a534c780&"
import script from "./realResults.vue?vue&type=script&lang=js&"
export * from "./realResults.vue?vue&type=script&lang=js&"
import style0 from "./realResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports